import { Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { resolvePage } from "@/shared/lib/page-registry";
import { PageFallbackSkeleton } from "@/shared/components";

export const Route = createFileRoute("/_protected/$")({
  component: CatchAllPage,
});

function CatchAllPage() {
  const { _splat } = Route.useParams();
  const { Component, params } = resolvePage(_splat ?? "");

  return (
    <Suspense fallback={<PageFallbackSkeleton />}>
      <Component {...params} />
    </Suspense>
  );
}
